export default __webpack_public_path__ + "static/media/hecho.30558340.png";